// extracted by mini-css-extract-plugin
export default {"header":"Header_header__PL+PU","main-image":"Header_main-image__kx+Ai"};